'use client';

import { useEffect, useState } from 'react';
import { isCapacitorNative } from '@/lib/universal-links';

export function useIsCapacitorNative(): boolean {
  const [isNative, setIsNative] = useState(false);

  useEffect(() => {
    setIsNative(isCapacitorNative());
  }, []);

  return isNative;
}
